(() => {
'use strict';
const config=JSON.parse(document.querySelector('#PTConfig')?.textContent||'{}');
const root=config.root||'/';
const cartUI=config.cartUI||{};
const tx=(key,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replace('['+k+']',String(v)),config.ui?.[key]||key);
const $=(s,e=document)=>e.querySelector(s), $$=(s,e=document)=>[...e.querySelectorAll(s)];
const money=n=>new Intl.NumberFormat(config.locale||'en-CA',{style:'currency',currency:config.currency||'CAD'}).format(Number(n||0)/100);
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const reduced=()=>config.animations===false||matchMedia('(prefers-reduced-motion: reduce)').matches||document.documentElement.dataset.reducedMotion==='true';
const clamp=n=>Math.max(0,Math.min(1,n));
const initializers=new WeakMap();
const controllers=new Set();
const overlay=$('#PTOverlay'), lightbox=$('#PTLightbox');
let moved=null,anchor=null,lastTrigger=null,cartBusy=false,activeGallery=null,cartCache=null;
let preferences={reduceMotion:false,largeText:false,contrast:false};
try{preferences={...preferences,...JSON.parse(localStorage.getItem('pt-accessibility')||'{}')}}catch{}

function applyPrefs(){
 document.documentElement.dataset.reducedMotion=String(preferences.reduceMotion);
 document.documentElement.dataset.largeText=String(preferences.largeText);
 document.documentElement.dataset.highContrast=String(preferences.contrast);
 document.dispatchEvent(new CustomEvent('pt:motion-change'));
}

function closePanel(){
 if(moved){
  if(anchor?.isConnected)anchor.replaceWith(moved);
  else moved.remove();
  moved=null;
  anchor=null;
 }
 overlay?.close();
 if(lastTrigger?.isConnected)lastTrigger.focus({preventScroll:true});
}

function openPanel(kind,trigger){
 const opener=trigger||document.activeElement;
 closePanel();
 lastTrigger=opener;
 overlay.dataset.kind=kind;
 const body=$('.pt-drawer-body',overlay);
 body.replaceChildren();
 overlay.setAttribute('aria-label',kind==='cart'?tx('bag_label'):'Pillow Talk');

 if(kind==='cart'){
  body.innerHTML=`<h2>${esc(config.cartHeading||'Your night in')}</h2><p class="pt-cart-status" role="status">${esc(cartUI.cart_loading_label||'Loading your bag…')}</p>`;
  loadCart();
 }else if(kind==='accessibility'){
  body.innerHTML=`<h2>${esc(tx('preferences_heading'))}</h2><div class="pt-preferences"><p>${esc(tx('preferences_intro'))}</p>${[['reduceMotion',tx('reduce_motion')],['largeText',tx('large_text')],['contrast',tx('contrast')]].map(([key,label])=>`<label><input type="checkbox" data-preference="${key}" ${preferences[key]?'checked':''}>${label}</label>`).join('')}<button class="cta" type="button" data-save-preferences>${esc(tx('save_preferences'))}</button><p role="status" data-preference-status></p></div>`;
 }else if(kind==='privacy'){
  body.innerHTML=`<h2>${esc(tx('privacy_heading'))}</h2><p>${esc(tx('privacy_intro'))}</p><div class="pt-preferences"><label><input type="checkbox" data-consent="analytics">${esc(tx('analytics'))}</label><label><input type="checkbox" data-consent="marketing">${esc(tx('marketing'))}</label><button type="button" class="cta" data-save-consent>${esc(tx('save_privacy'))}</button><p role="status" data-consent-status></p></div>`;
  loadPrivacy();
 }else{
  const source=$(`[data-overlay-source="${kind}"]`);
  if(source){
   anchor=document.createComment('pt-overlay-home');
   source.before(anchor);
   moved=source;
   body.append(source);
   const heading=$('h2,h3',source);
   overlay.setAttribute('aria-label',heading?.textContent||'Pillow Talk');
   const tabs=$('.pt-tabs',source);
   if(tabs){
    tabs.dataset.active='chocolate';
    $('.pt-tab-button',tabs)?.classList.add('active');
   }
  }else{
   body.innerHTML=`<h2>Pillow Talk</h2><p>${esc(tx('more_coming'))}</p>`;
  }
 }

 if(!overlay.open)overlay.showModal();
}

async function request(url,options){
 const res=await fetch(url,{
  credentials:'same-origin',
  headers:{
   'Content-Type':'application/json',
   'Accept':'application/json'
  },
  ...options
 });

 let data;

 try{
  data=await res.json();
 }catch{
  throw new Error(tx('api_error'));
 }

 if(!res.ok||data.status>=400){
  throw new Error(data.description||data.message||config.cartError);
 }

 return data;
}

async function loadCart(){
 try{
  const data=await request(root+'cart.js');
  cartCache=data;
  renderCart(data);
 }catch(e){
  const status=$('.pt-cart-status',overlay);
  if(status)status.textContent=e.message;
 }
}

function updateCartCount(n){
 $$('[data-cart-count]').forEach(el=>{
  el.textContent=String(n);
  el.hidden=n===0;
 });
}

/*
 * Central cart bridge for custom sections.
 *
 * The native Pillow Talk cart lives in this file, so custom AJAX buy boxes
 * should notify this controller instead of trying to open the drawer directly.
 * The Compact Buy Box already emits cart:refresh immediately after a successful
 * add and then emits cart:updated with the authoritative /cart.js payload.
 */
function currentVisibleCartCount(){
 if(cartCache&&Number.isFinite(Number(cartCache.item_count))){
  return Number(cartCache.item_count);
 }

 const count=
  Number(
   $('[data-cart-count]')?.textContent
  );

 return Number.isFinite(count)
  ? count
  : 0;
}

function handleExternalCartSignal(event){
 const detail=event?.detail||{};
 const fromBuyBox=detail.source==='pt-buy-box';
 const suppliedCart=detail.cart&&typeof detail.cart==='object'
  ? detail.cart
  : null;
 const suppliedCount=Number(
  detail.item_count??
  suppliedCart?.item_count
 );

 /*
  * The buy box sends cart:refresh synchronously as soon as Shopify confirms
  * the add. Open the native dialog immediately and optimistically increment
  * the header badge while the authoritative cart is fetched.
  */
 if(fromBuyBox&&event.type==='cart:refresh'&&!suppliedCart){
  const optimisticCount=
   currentVisibleCartCount()+
   Math.max(1,Number(detail.quantity)||1);

  updateCartCount(optimisticCount);

  if(!overlay?.open||overlay.dataset.kind!=='cart') {
   openPanel('cart',document.activeElement);
  }else{
   loadCart();
  }

  return;
 }

 /*
  * When a caller provides the real cart payload, use it immediately. This
  * updates the header badge without waiting for the drawer to be opened.
  */
 if(suppliedCart){
  cartCache=suppliedCart;
  renderCart(suppliedCart);

  if(fromBuyBox&&(!overlay?.open||overlay.dataset.kind!=='cart')){
   openPanel('cart',document.activeElement);
   renderCart(suppliedCart);
  }

  return;
 }

 if(Number.isFinite(suppliedCount)){
  updateCartCount(suppliedCount);
 }

 /*
  * cart:updated without a payload is used by the theme's own quantity
  * controls. If the drawer is already open, simply reconcile the cart.
  * For the buy box, also guarantee the drawer is open.
  */
 if(fromBuyBox&&(!overlay?.open||overlay.dataset.kind!=='cart')){
  openPanel('cart',document.activeElement);
  return;
 }

 loadCart();
}

function renderCart(cart){
 updateCartCount(cart.item_count);

 if(!overlay.open||overlay.dataset.kind!=='cart')return;

 const body=$('.pt-drawer-body',overlay);
 const previousProgress=Number($('.pt-shipping-track',body)?.getAttribute('aria-valuenow'))||0;

 if(overlay.dataset.kind!=='cart')return;

 body.innerHTML=`
  <h2>${esc(config.cartHeading||'Your night in')}</h2>
  <div class="cart-content">
   ${
    cart.item_count===0
     ? `
      <div class="empty-cart">
       <h3>${esc(config.emptyHeading||'A little empty in here.')}</h3>
       <p>${esc(cartUI.cart_empty_copy)}</p>
       <a class="cta" href="${esc(root)}#offers" data-close-link>${esc(cartUI.cart_browse_label)} →</a>
      </div>
     `
     : `
      <div class="pt-shipping" role="status">
       ${shippingMarkup(cart.total_price,cart.currency)}
      </div>

      <div class="cart-lines">
       ${cart.items.map((line,i)=>`
        <article class="cart-line">
         ${
          line.image
           ? `<img src="${esc(line.image)}" alt="${esc(line.product_title)}" width="100" height="150">`
           : ''
         }

         <div>
          <h3><a href="${esc(line.url)}">${esc(line.product_title)}</a></h3>

          <p>
           ${line.variant_title&&line.variant_title!=='Default Title'?esc(line.variant_title):''}
          </p>

          ${
           line.properties?.Contents
            ? `<p>${esc(line.properties.Contents)} · ${esc(line.properties.Supply||'')}</p>`
            : ''
          }

          ${
           line.selling_plan_allocation
            ? `<p>${esc(line.selling_plan_allocation.selling_plan.name)}</p>`
            : `<p>${esc(cartUI.cart_once_label)}</p>`
          }

          <div class="line-bottom">
           <div class="cart-quantity">
            <button
             type="button"
             data-cart-line="${esc(line.key)}"
             data-cart-quantity="${line.quantity-1}"
             aria-label="${esc(tx('remove_one',{product:line.product_title}))}"
            >−</button>

            <span>${line.quantity}</span>

            <button
             type="button"
             data-cart-line="${esc(line.key)}"
             data-cart-quantity="${line.quantity+1}"
             aria-label="${esc(tx('add_one',{product:line.product_title}))}"
            >+</button>
           </div>

           <strong>${money(line.final_line_price)}</strong>
          </div>

          <button
           class="remove-line"
           type="button"
           data-cart-line="${esc(line.key)}"
           data-cart-quantity="0"
          >
           ${esc(cartUI.cart_remove_label)}
          </button>
         </div>
        </article>
       `).join('')}
      </div>

      <div class="cart-totals">
       ${(cart.cart_level_discount_applications||[]).map(d=>`
        <div class="cart-discount">
         <span>${esc(d.title)}</span>
         <strong>−${money(d.total_allocated_amount)}</strong>
        </div>
       `).join('')}

       <div>
        <span>${esc(cartUI.cart_subtotal_label)}</span>
        <strong>${money(cart.total_price)} ${esc(config.currency)}</strong>
       </div>

       <p>${esc(config.shippingNote)}</p>

       <form method="post" action="${esc(config.cartUrl||root+'cart')}">
        <button class="cta" type="submit" name="checkout">
         ${esc(config.checkoutLabel||'Checkout')} →
        </button>
       </form>

       <button class="text-link" type="button" data-close-overlay>
        ${esc(cartUI.cart_keep_label)}
       </button>
      </div>
     `
   }

   ${
    cartUI.cart_show_recommendation
     ? `
      <div class="cart-recommendation">
       <img
        src="${esc(cartUI.recommendation_image)}"
        alt=""
        width="64"
        height="85"
       >
       <div>
        <p>${esc(cartUI.cart_recommendation_heading)}</p>
        <a href="${esc(cartUI.recommendation_url)}" data-close-link>
         ${esc(cartUI.cart_recommendation_link)} →
        </a>
       </div>
      </div>
     `
     : ''
   }

   <p class="pt-cart-status" role="status"></p>
  </div>
 `;

 animateShipping(body,previousProgress);
}

async function addItem(item,button,errorElement){
 if(button?.disabled)return;

 const old=button?.innerHTML;

 if(button){
  button.disabled=true;
  button.setAttribute('aria-busy','true');
 }

 try{
  await request(config.cartAdd||root+'cart/add.js',{
   method:'POST',
   body:JSON.stringify({items:[item]})
  });

  if(errorElement)errorElement.hidden=true;

  openPanel('cart',button);
  document.dispatchEvent(new CustomEvent('cart:updated'));

  const announce=$('[data-announcer]');
  if(announce)announce.textContent=tx('added');

 }catch(e){
  if(errorElement){
   errorElement.textContent=e.message;
   errorElement.hidden=false;
  }else{
   openPanel('cart',button);
   const status=$('.pt-cart-status',overlay);
   if(status)status.textContent=e.message;
  }
 }finally{
  if(button){
   button.disabled=false;
   button.removeAttribute('aria-busy');

   if(old!==undefined){
    button.innerHTML=old;
   }
  }
 }
}

function shippingMarkup(subtotal,currency=config.currency){
 const state=PTCommerce.shipping(subtotal,currency,config.shipping);

 if(!state.eligible){
  return `<p>${esc(cartUI.shipping_pending||'Shipping eligibility and charges are confirmed at checkout.')}</p>`;
 }

 const text=state.attained
  ? (cartUI.shipping_attained||'Your subtotal meets the free standard shipping minimum. Destination confirmed at checkout.')
  : (cartUI.shipping_away||'[amount] away from the free standard shipping minimum.').replace('[amount]',money(state.remaining));

 const explanation=(cartUI.shipping_explanation||'Free shipping on orders over [amount] [currency] for eligible destinations. After discounts; before tax and shipping. Renewal shipping may differ.')
  .replace('[amount]',money(state.threshold))
  .replace('[currency]',currency);

 return `
  <p>${esc(text)}</p>

  <div
   class="pt-shipping-track"
   role="progressbar"
   aria-label="${esc(tx('shipping_progress'))}"
   aria-valuemin="0"
   aria-valuemax="100"
   aria-valuenow="${Math.round(state.progress)}"
  >
   <div
    class="pt-shipping-fill"
    style="--progress:${state.progress}%"
   >
    ${
     cartUI.cart_show_marker!==false
      ? `<img
          class="pt-shipping-marker"
          src="${esc(cartUI.marker||root+'assets/pt-deck-eye-mask.webp')}"
          alt=""
          width="38"
          height="34"
         >`
      : ''
    }
   </div>
  </div>

  <small>${esc(explanation)}</small>
 `;
}

function animateShipping(scope,from=0){
 const fill=$('.pt-shipping-fill',scope);

 if(!fill||reduced()||config.designMode)return;

 fill.style.width=from+'%';
 fill.getBoundingClientRect();

 requestAnimationFrame(()=>{
  if(fill.isConnected){
   fill.style.width='var(--progress)';
  }
 });
}

function updateShipping(scope=document){
 $$('[data-shipping-status]',scope).forEach(el=>{
  const old=Number($('.pt-shipping-track',el)?.getAttribute('aria-valuenow'))||0;

  el.innerHTML=shippingMarkup(
   Number(el.dataset.subtotal)||0,
   el.dataset.currency||config.currency
  );

  animateShipping(el,old);
 });
}

function updateOrderRewards(form,price,currency,data,mode,servings){
 const el=$('[data-order-rewards]',form);
 if(!el)return;

 const selected=Number.isFinite(price)&&price>=0;
 const review=el.dataset.review==='true';

 const offers=PTCommerce.offers(data,'subscribe');

 const first=offers.find(o=>o.servings===30&&o.valid);
 const second=offers.find(o=>o.servings===45&&o.valid);

 const shipEnabled=review||el.dataset.shippingVerified==='true';
 const giftEnabled=review||el.dataset.giftVerified==='true';

 const subscription=selected&&mode==='subscribe';

 const shipReached=subscription&&shipEnabled&&servings>=30;
 const giftReached=subscription&&giftEnabled&&servings>=45;

 const shipNode=$('[data-reward-shipping]',el);
 const giftNode=$('[data-reward-gift]',el);

 giftNode.hidden=!giftEnabled;

 el.classList.toggle('has-gift',giftEnabled);

 shipNode.classList.toggle('is-reached',shipReached);
 giftNode.classList.toggle('is-reached',giftReached);

 el.style.setProperty('--shipping-stop',giftEnabled?'50%':'100%');
 el.style.setProperty('--gift-stop','100%');

 let percent=0;

 if(subscription&&first&&second&&second.price>first.price){
  percent=price<=first.price
   ? 50*price/first.price
   : 50+50*(price-first.price)/(second.price-first.price);

  percent=Math.min(100,Math.max(0,percent));

 }else if(subscription){
  percent=servings>=45
   ? 100
   : servings>=30
    ? 50
    : 0;
 }

 if(!shipEnabled&&!giftEnabled){
  percent=0;
 }else if(!giftEnabled){
  percent=shipReached?100:0;
 }else if(!shipEnabled&&!giftReached){
  percent=0;
 }

 $('[data-rewards-fill]',el).style.width=percent+'%';

 const track=$('.pt-rewards-track',el);

 track.setAttribute(
  'aria-valuenow',
  String(Math.round(percent))
 );

 const status=
  !selected
   ? 'Select an available subscription to see your rewards.'
   : mode==='once'
    ? 'Subscription rewards start with the 30-serving plan.'
    : giftReached&&shipReached
     ? 'Free shipping + surprise gift unlocked.'
     : giftReached
      ? 'Surprise gift unlocked.'
      : shipReached
       ? 'Free shipping unlocked. Choose 45 servings for a surprise gift.'
       : 'Subscription rewards are awaiting store configuration.';

 const previewSuffix=review?' Preview only.':'';

 track.setAttribute(
  'aria-valuetext',
  status+previewSuffix
 );

 $('[data-reward-shipping-note]',el).textContent=
  shipEnabled
   ? '30-serving subscription'
   : 'Confirmed at checkout';

 $('[data-reward-gift-note]',el).textContent=
  '45-serving subscription';

 const summary=$('[data-rewards-summary]',el);

 if(summary){
  summary.textContent='';
  summary.hidden=true;
 }
}

function initForm(el,signal){
 const form=$('[data-offer-form]',el);
 const source=$('[data-offer-data]',el);

 if(!form||!source)return;

 let data,ui;

 try{
  data=JSON.parse(source.textContent);

  ui=JSON.parse(
   $('[data-offer-ui]',el)?.textContent||'{}'
  );

  const mapping=$('[data-offer-mapping]',el);

  if(mapping){
   data.variants.push(
    ...JSON.parse(mapping.textContent).variants
   );
  }

 }catch{
  return;
 }

 const button=$('[data-product-submit]',form);
 const rows=$('[data-supply-rows]',form);
 const planSelect=$('select[name=selling_plan]',form);

 let mode='subscribe';
 let selected=null;
 let plan=null;
 let busy=false;

 const standaloneVariants=(data.variants||[]).filter(v=>
  v.available&&
  !v.requires_plan&&
  Number.isInteger(v.price)&&
  v.price>0
 );

 const standalone=
  !PTCommerce.offers(data,'subscribe').some(o=>o.servings>15&&o.available)&&
  !PTCommerce.offers(data,'once').some(o=>o.servings===15&&o.available)&&
  standaloneVariants.length===1
   ? {
      variant:standaloneVariants[0],
      price:standaloneVariants[0].price,
      available:true,
      standalone:true
     }
   : null;

 const eligible=(offer,wanted)=>
  wanted==='once'
   ? offer.servings===15
   : offer.servings>15;

 if(standalone){
  mode='once';
 }

 function chooseSupply(){
  const choices=PTCommerce.offers(data,mode).filter(o=>
   eligible(o,mode)&&o.available
  );

  if(!choices.some(o=>o.servings===selected)){
   selected=(
    choices.find(o=>o.servings===45)||
    choices[0]
   )?.servings||null;
  }
 }

 function renderRows(){
  chooseSupply();

  if(standalone){
   const pending=[30,45,60].map(n=>`
    <label
     class="pt-supply unavailable mode-inactive"
     data-tier="${n}"
    >
     <input
      type="radio"
      name="supply"
      value="${n}"
      disabled
     >

     <img
      src="${esc(ui.image)}"
      alt=""
      width="38"
      height="54"
     >

     <span class="pt-supply-copy">
      <strong>
       ${n} ${esc(ui.servings_label)}
      </strong>

      <small>
       ${esc(
        ({
         30:ui.thirty_label,
         45:ui.fortyfive_label,
         60:ui.sixty_label
        })[n]
       )}
      </small>
     </span>

     <span class="pt-supply-price">
      <small>
       ${esc(ui.unavailable_label)}
      </small>
     </span>
    </label>
   `).join('');

   rows.innerHTML=`
    <label class="pt-supply pt-supply-standalone">
     <input
      type="radio"
      name="supply"
      value="current"
      checked
     >

     <img
      src="${esc(ui.image)}"
      alt=""
      width="38"
      height="54"
     >

     <span class="pt-supply-copy">
      <strong>
       ${esc(data.product_title||'Current Shopify product')}
      </strong>
     </span>

     <span class="pt-supply-price">
      <strong class="pt-current-price">
       ${money(standalone.price)}
      </strong>
     </span>
    </label>

    ${pending}
   `;

   sync();
   return;
  }

  const onceOffers=
   PTCommerce.offers(data,'once');

  const subscribeOffers=
   PTCommerce.offers(data,'subscribe');

  const choices=
   PTCommerce.presentation(
    onceOffers.map(o=>
     o.servings===15
      ? o
      : subscribeOffers.find(
         s=>s.servings===o.servings
        )
    )
   );

  rows.innerHTML=choices.map(o=>{
   const active=eligible(o,mode);

   const disabled=
    !active||
    !o.available||
    busy;

   const discount=
    o.valid
     ? PTCommerce.savingsBasis(
        data,
        o.price,
        o.servings
       )
     : null;

   const star=o.servings===45;

   const priceMarkup=
    o.valid
     ? `
      <span class="pt-supply-price">
       <span class="pt-price-line">
        ${
         discount
          ? `
           <s class="pt-original-price">
            ${money(discount.total)}
           </s>
          `
          : ''
        }

        <strong class="pt-current-price">
         ${money(o.price)}
        </strong>
       </span>

       ${
        discount
         ? `
          <span class="pt-discount-pill">
           ${discount.percent}% OFF
          </span>
         `
         : ''
       }

       ${
        !o.variant.available
         ? `
          <small class="pt-soldout-label">
           ${esc(ui.soldout_label)}
          </small>
         `
         : ''
       }
      </span>
     `
     : `
      <span class="pt-supply-price">
       <small>
        ${esc(o.reason||ui.unavailable_label)}
       </small>
      </span>
     `;

   return `
    <label
     class="
      pt-supply
      ${o.servings===45?'pt-supply-featured':''}
      ${star?'has-value-star':''}
      ${disabled?'unavailable':''}
      ${!active?'mode-inactive':''}
     "
     data-tier="${o.servings}"
     title="${esc(o.reason||'')}"
    >

     ${
      star
       ? `
        <span
         class="pt-value-star"
         aria-label="Best value"
        >★</span>
       `
       : ''
     }

     <input
      type="radio"
      name="supply"
      value="${o.servings}"
      ${selected===o.servings?'checked':''}
      ${disabled?'disabled':''}
     >

     <img
      src="${esc(ui.image)}"
      alt=""
      width="38"
      height="54"
     >

     <span class="pt-supply-copy">
      <strong>
       ${o.servings} ${esc(ui.servings_label)}
      </strong>

      <small>
       ${esc(
        ({
         15:ui.trial_label,
         30:ui.thirty_label,
         45:ui.fortyfive_label,
         60:ui.sixty_label
        })[o.servings]
       )}
      </small>

      <span class="pt-tier-badges">
       ${
        o.recommended
         ? `
          <span class="pt-recommended">
           ${esc(ui.recommended_label)}
          </span>
         `
         : ''
       }
      </span>
     </span>

     ${priceMarkup}

     ${
      discount
       ? `
        <span class="visually-hidden">
         Discount compared with
         ${o.servings/15}
         one-time 15-serving orders.
        </span>
       `
       : ''
     }
    </label>
   `;
  }).join('');

  sync();
 }

 function sync(){
  $$('[name=purchase_mode]',form).forEach(r=>{
   r.disabled=busy;
   r.checked=r.value===mode;
  });

  const offer=
   standalone||
   PTCommerce.offers(data,mode).find(o=>
    o.servings===selected&&
    eligible(o,mode)&&
    o.available
   );

  const previous=planSelect.value;

  planSelect.replaceChildren(
   ...(
    mode==='subscribe'
     ? (offer?.allocations||[])
     : []
   ).map(a=>
    new Option(
     a.name,
     String(a.id)
    )
   )
  );

  if(
   [...planSelect.options].some(
    o=>o.value===previous
   )
  ){
   planSelect.value=previous;
  }

  plan=offer?.allocations?.find(
   a=>String(a.id)===planSelect.value
  );

  planSelect.disabled=
   mode!=='subscribe'||
   !offer||
   busy;

  const planChoice=
   $('[data-plan-choice]',form);

  if(planChoice){
   planChoice.hidden=true;
  }

  const price=
   standalone
    ? standalone.price
    : mode==='subscribe'
     ? plan?.price
     : offer?.price;

  const id=$('[data-variant-id]',form);

  id.value=offer?.variant.id||'';
  id.disabled=!offer;

  button.disabled=!offer||busy;
  button.dataset.offerAvailable=
   String(!!offer);

  $('[data-add-text]',button).textContent=
   offer
    ? (
       mode==='subscribe'
        ? ui.subscribe_label
        : ui.add_label
      )
    : ui.unavailable_label;

  $('[data-selected-price]',form).textContent=
   offer
    ? money(price)
    : '';

  const contents=
   $('[data-contents]',form);

  if(contents){
   contents.textContent='';
   contents.hidden=true;
  }

  const terms=
   $('[data-plan-terms]',form);

  if(terms){
   terms.textContent='';
   terms.hidden=true;
  }

  const savings=
   $('[data-savings]',form);

  if(savings){
   savings.textContent='';
   savings.hidden=true;
  }

  updateOrderRewards(
   form,
   offer?price:null,
   data.currency,
   data,
   mode,
   selected
  );

  const shipping=
   $('[data-shipping-status]',form);

  if(shipping){
   shipping.dataset.subtotal=
    String(price||0);

   updateShipping(form);
  }

  const sticky=
   $('[data-sticky-price]');

  if(sticky){
   sticky.textContent=
    standalone
     ? `${money(price)} · ${data.product_title||'Current Shopify product'} · ${ui.once_label}`
     : offer
      ? `${money(price)} · ${selected} ${ui.servings_label} · ${mode==='subscribe'?ui.subscribe_label:ui.once_label}`
      : ui.supply_label.replace(/^\d+\.\s*/,'');
  }
 }

 form.addEventListener(
  'change',
  e=>{
   if(e.target.name==='purchase_mode'){
    mode=e.target.value;
    renderRows();

   }else if(e.target.name==='supply'){
    if(standalone)return;

    selected=Number(e.target.value);

    renderRows();

    $(
     `[name=supply][value="${selected}"]`,
     form
    )?.focus({
     preventScroll:true
    });

   }else if(e.target.name==='selling_plan'){
    sync();
   }
  },
  {signal}
 );

 const modeSwitch=
  $('.pt-mode-switch',form);

 let switchStart=null;
 let suppressSwitchClickUntil=0;

 modeSwitch.addEventListener(
  'pointerdown',
  e=>{
   if(!busy&&e.isPrimary){
    switchStart={
     x:e.clientX,
     y:e.clientY
    };
   }
  },
  {signal}
 );

 modeSwitch.addEventListener(
  'pointercancel',
  ()=>{
   switchStart=null;
  },
  {signal}
 );

 modeSwitch.addEventListener(
  'pointerup',
  e=>{
   if(!switchStart)return;

   const dx=
    e.clientX-switchStart.x;

   const dy=
    e.clientY-switchStart.y;

   switchStart=null;

   if(
    !busy&&
    Math.abs(dx)>30&&
    Math.abs(dx)>Math.abs(dy)
   ){
    mode=
     dx>0
      ? 'subscribe'
      : 'once';

    renderRows();

    suppressSwitchClickUntil=
     performance.now()+250;

    $(
     `[name=purchase_mode][value="${mode}"]`,
     form
    )?.focus({
     preventScroll:true
    });
   }
  },
  {signal}
 );

 modeSwitch.addEventListener(
  'click',
  e=>{
   if(
    performance.now()<
    suppressSwitchClickUntil
   ){
    e.preventDefault();
    e.stopPropagation();
   }
  },
  {
   capture:true,
   signal
  }
 );

 form.addEventListener(
  'submit',
  async e=>{
   e.preventDefault();

   if(busy||button.disabled)return;

   const offer=
    standalone||
    PTCommerce.offers(data,mode).find(o=>
     o.servings===selected&&
     eligible(o,mode)&&
     o.available
    );

   if(!offer)return;

   const item=
    PTCommerce.cartItem(
     offer,
     mode,
     plan
    );

   if(!item)return;

   busy=true;

   form.setAttribute(
    'aria-busy',
    'true'
   );

   $$(
    'input,select',
    form
   ).forEach(x=>{
    x.disabled=true;
   });

   try{
    await addItem(
     item,
     button,
     $('.pt-form-error',form)
    );
   }finally{
    busy=false;

    form.removeAttribute(
     'aria-busy'
    );

    renderRows();
   }
  },
  {signal}
 );

 renderRows();
}

function initGallery(el,signal){
 const slides=
  $$('[data-gallery-slide]',el)
   .filter(slide=>!!$('img',slide));

 $$('[data-gallery-slide]',el)
  .forEach(slide=>{
   slide.hidden=!slides.includes(slide);
  });

 el.hidden=!slides.length;

 if(!slides.length)return;

 let index=0;
 let start=0;
 let startY=0;

 const thumbs=
  $('[data-thumbnails]',el);

 thumbs.replaceChildren(
  ...slides.map((slide,i)=>{
   const b=document.createElement('button');

   b.type='button';

   b.setAttribute(
    'aria-label',
    tx('view_image',{
     number:i+1
    })
   );

   const image=$('img',slide);

   if(image){
    const img=image.cloneNode();

    img.removeAttribute('id');
    img.removeAttribute('style');
    img.removeAttribute('data-shopify-editor-block');

    img.alt='';

    b.append(img);
   }

   b.addEventListener(
    'click',
    ()=>move(i),
    {signal}
   );

   return b;
  })
 );

 function move(i){
  index=
   (i+slides.length)%slides.length;

  slides.forEach((s,j)=>{
   s.hidden=j!==index;
   s.classList.toggle(
    'active',
    j===index
   );
  });

  $$('button',thumbs).forEach((b,j)=>
   b.setAttribute(
    'aria-current',
    String(j===index)
   )
  );

  $('[data-gallery-count]',el).textContent=
   (index+1)+' / '+slides.length;
 }

 $('[data-gallery-prev]',el)
  .addEventListener(
   'click',
   ()=>move(index-1),
   {signal}
  );

 $('[data-gallery-next]',el)
  .addEventListener(
   'click',
   ()=>move(index+1),
   {signal}
  );

 const stage=
  $('.pt-gallery-stage',el);

 stage.addEventListener(
  'touchstart',
  e=>{
   if(e.target.closest('button'))return;

   start=e.changedTouches[0].clientX;
   startY=e.changedTouches[0].clientY;
  },
  {
   passive:true,
   signal
  }
 );

 stage.addEventListener(
  'touchend',
  e=>{
   if(e.target.closest('button'))return;

   const dx=
    start-e.changedTouches[0].clientX;

   const dy=
    startY-e.changedTouches[0].clientY;

   if(
    Math.abs(dx)>35&&
    Math.abs(dx)>Math.abs(dy)
   ){
    move(
     index+(dx>0?1:-1)
    );

    e.preventDefault();
   }
  },
  {
   passive:false,
   signal
  }
 );

 move(0);
}

function initAnnouncement(el,signal){
 const messages=
  $$('.pt-announcement-message',el);

 if(!messages.length)return;

 el.classList.add('is-initialized');

 let n=0;
 let paused=false;

 const show=i=>
  messages.forEach((m,j)=>{
   m.classList.toggle(
    'active',
    i===j
   );

   m.setAttribute(
    'aria-hidden',
    String(i!==j)
   );

   m.tabIndex=
    i===j
     ? 0
     : -1;
  });

 show(0);

 el.addEventListener(
  'mouseenter',
  ()=>paused=true,
  {signal}
 );

 el.addEventListener(
  'mouseleave',
  ()=>paused=false,
  {signal}
 );

 el.addEventListener(
  'focusin',
  ()=>paused=true,
  {signal}
 );

 el.addEventListener(
  'focusout',
  ()=>paused=false,
  {signal}
 );

 const timer=setInterval(()=>{
  if(
   !paused&&
   !reduced()&&
   !document.hidden&&
   !config.designMode
  ){
   show(
    n=(n+1)%messages.length
   );
  }
 },Number(el.dataset.delay)||5000);

 signal.addEventListener(
  'abort',
  ()=>clearInterval(timer)
 );
}

function syncTickerJoin(el){
 const shell=
  el.closest(
   '.pt-ticker-shell--hero-join,.pt-ticker-shell--story-join'
  );

 if(!shell)return;

 const next=
  shell.classList.contains(
   'pt-ticker-shell--story-join'
  );

 const section=
  el.closest('.shopify-section');

 const adjacent=
  next
   ? section?.nextElementSibling
   : section?.previousElementSibling;

 const comparison=
  next
   ? adjacent?.querySelector('.pt-comparison')
   : null;

 shell.classList.toggle(
  'has-comparison-background',
  !!comparison
 );

 if(comparison){
  comparison.style.setProperty(
   '--ticker-overlap',
   shell.offsetHeight+'px'
  );

  return;
 }

 const hero=
  adjacent?.querySelector(
   next
    ? '[data-scroll-story]'
    : '.hero'
  );

 shell.classList.toggle(
  'has-hero-background',
  !!hero
 );

 if(!hero)return;

 const surface=
  getComputedStyle(hero);

 const texture=
  getComputedStyle(
   hero,
   '::before'
  );

 shell.style.setProperty(
  '--ticker-join-bg',
  next
   ? surface.getPropertyValue('--r3-bg')||
     surface.backgroundColor
   : surface.backgroundColor
 );

 shell.style.setProperty(
  '--ticker-join-texture',
  texture.backgroundImage
 );

 shell.style.setProperty(
  '--ticker-join-size',
  texture.backgroundSize
 );

 shell.style.setProperty(
  '--ticker-join-opacity',
  texture.opacity
 );

 shell.style.setProperty(
  '--ticker-join-blend',
  texture.mixBlendMode
 );
}

function initMarquee(el,signal){
 const track=
  $('.marquee-track',el);

 const group=
  $('.marquee-group',el);

 if(!track||!group)return;

 const cleanClone=node=>{
  const clone=node.cloneNode(true);

  clone.setAttribute(
   'aria-hidden',
   'true'
  );

  [
   clone,
   ...$$(
    '[id], [data-shopify-editor-block]',
    clone
   )
  ].forEach(item=>{
   item.removeAttribute('id');
   item.removeAttribute(
    'data-shopify-editor-block'
   );
  });

  return clone;
 };

 const rebuild=()=>{
  if(signal.aborted)return;

  $$(
   '[data-pt-clone]',
   track
  ).forEach(node=>node.remove());

  $$(
   '[data-pt-fill]',
   group
  ).forEach(node=>node.remove());

  const originals=
   [...group.children];

  if(
   !originals.length||
   !group.scrollWidth
  )return;

  for(
   let copies=0;
   group.scrollWidth<el.clientWidth&&copies<12;
   copies++
  ){
   originals.forEach(node=>{
    const clone=cleanClone(node);

    clone.dataset.ptFill='';

    group.append(clone);
   });
  }

  if(
   el.dataset.alternateSeparators==='true'
  ){
   if(group.children.length%2){
    originals.forEach(node=>{
     const copy=cleanClone(node);

     copy.dataset.ptFill='';

     group.append(copy);
    });
   }

   [...group.children].forEach((item,index)=>{
    const separator=
     $('.marquee-star',item);

    if(separator){
     separator.textContent=
      index%2
       ? '♥'
       : '✦';
    }
   });
  }

  const clone=cleanClone(group);

  clone.dataset.ptClone='true';

  track.append(clone);

  syncTickerJoin(el);
 };

 track.style.setProperty(
  '--marquee-duration',
  el.dataset.duration+'s'
 );

 track.style.setProperty(
  '--marquee-mobile-duration',
  el.dataset.mobileDuration+'s'
 );

 let lastWidth=0;

 const observer=
  new ResizeObserver(entries=>{
   const width=
    entries[0].contentRect.width;

   if(Math.abs(width-lastWidth)>1){
    lastWidth=width;
    rebuild();
   }
  });

 observer.observe(el);

 signal.addEventListener(
  'abort',
  ()=>observer.disconnect()
 );

 document.fonts.ready.then(rebuild);

 rebuild();
}

function initHeroNumbers(group,signal){
 const animations=[];

 const cancel=()=>
  animations.forEach(
   animation=>animation.cancel()
  );

 signal.addEventListener(
  'abort',
  cancel
 );

 const motion=
  matchMedia(
   '(prefers-reduced-motion: reduce)'
  );

 motion.addEventListener(
  'change',
  ()=>{
   if(reduced())cancel();
  },
  {signal}
 );

 document.addEventListener(
  'pt:motion-change',
  ()=>{
   if(reduced())cancel();
  },
  {signal}
 );

 document.fonts.ready.then(()=>{
  if(
   signal.aborted||
   reduced()||
   config.designMode
  )return;

  $$('b',group).forEach((number,index)=>
   animations.push(
    number.animate(
     [
      {
       opacity:0,
       transform:'translateY(14px) scale(.72)'
      },
      {
       opacity:1,
       transform:'translateY(-2px) scale(1.08)',
       offset:.7
      },
      {
       opacity:1,
       transform:'translateY(0) scale(1)'
      }
     ],
     {
      duration:650,
      delay:index*110,
      easing:'cubic-bezier(.22,.75,.25,1)',
      fill:'backwards'
     }
    )
   )
  );
 });
}

function initScroll(el,signal){
 const opts=
  $('[data-story-settings]',el)?.dataset||{};

 const scene=
  $('.pt-story-scene',el);

 const art=
  $('[data-wrapper-art]',el);

 const lines=
  $$('.word-mask>div',el);

 if(!scene||!lines.length)return;

 const originals=
  new Map(
   lines.map(line=>[
    line,
    line.innerHTML
   ])
  );

 const mq=
  matchMedia('(max-width:991px)');

 let frame=0;
 let rows=[];
 let height=0;
 let enabled=false;
 let lastWidth=0;
 let artShift=0;
 let textExit=0;

 const ingredientCTA=
  $('[data-ingredient-cta]',el);

 const ingredients=
  $('[data-story-ingredients]',el);

 const ingredientRows=
  $$('[data-ingredient-reveal]',el);

 const finale=
  $('[data-pouch-finale]',el);

 const pouchPoints=
  $$('.pt-pouch-point',el);

 const connectors=
  $('[data-ingredient-connectors]',el);

 const ingredientSpan=
  ingredients
   ? 1.52
   : 0;

 const pouchSpan=
  finale
   ? 5.5
   : 0;

 let readingExtra=0;
 let pouchHeight=0;
 let pouchTop=0;
 let pairCentre=0;
 let pairBottom=0;

 const words=
  $('.ritual-words',el);

 const smooth=p=>{
  p=clamp(p);
  return p*p*(3-2*p);
 };

 const ease=p=>
  1-Math.pow(
   1-clamp(p),
   3
  );

 function split(){
  rows=[];

  lines.forEach(line=>{
   line.innerHTML=
    originals.get(line);

   line.style.transform='none';

   const tokens=[];

   function read(node,em=false,strong=false){
    if(node.nodeType===3){
     node.textContent
      .split(/\s+/)
      .filter(Boolean)
      .forEach(word=>
       tokens.push({
        word,
        em,
        strong
       })
      );

     return;
    }

    if(node.nodeName==='BR'){
     tokens.push({
      break:true
     });

     return;
    }

    [...node.childNodes].forEach(child=>
     read(
      child,
      em||node.nodeName==='EM',
      strong||node.nodeName==='STRONG'
     )
    );
   }

   read(line);

   line.replaceChildren();

   tokens.forEach(token=>{
    if(token.break){
     line.append(
      document.createElement('br')
     );

     return;
    }

    const word=
     document.createElement('span');

    word.className=
     'pt-story-measure';

    word.textContent=
     token.word;

    token.node=word;

    line.append(
     word,
     document.createTextNode(' ')
    );
   });

   const groups=[];
   let top=null;

   tokens.forEach(token=>{
    if(token.break){
     top=null;
     return;
    }

    const y=
     token.node.offsetTop;

    if(
     top===null||
     Math.abs(y-top)>3
    ){
     groups.push([]);
     top=y;
    }

    groups[
     groups.length-1
    ].push(token);
   });

   line.replaceChildren();

   groups.forEach(words=>{
    const mask=
     document.createElement('span');

    const text=
     document.createElement('span');

    mask.className=
     'pt-story-row';

    text.className=
     'pt-story-row-text';

    let parent=text;
    let previous='';

    words.forEach((token,i)=>{
     const kind=
      token.em
       ? 'em'
       : token.strong
        ? 'strong'
        : '';

     if(
      kind!==previous||
      i===0
     ){
      parent=
       kind
        ? document.createElement(kind)
        : text;

      if(kind){
       text.append(parent);
      }

      previous=kind;
     }

     if(i){
      parent.append(
       document.createTextNode(' ')
      );
     }

     parent.append(
      document.createTextNode(
       token.word
      )
     );
    });

    mask.append(text);

    line.append(mask);

    rows.push(text);
   });
  });
 }

 function measure(){
  if(signal.aborted)return;

  enabled=
   opts.motion==='true'&&
   (
    !mq.matches||
    opts.mobileMotion==='true'
   )&&
   !reduced();

  el.dataset.storyReady='false';

  el.style.setProperty(
   '--story-art-y',
   '0px'
  );

  el.style.setProperty(
   '--story-text-y',
   '0px'
  );

  el.style.setProperty(
   '--pouch-pair-scale',
   '1'
  );

  split();

  height=
   enabled
    ? innerHeight
    : scene.offsetHeight;

  const range=
   Math.max(
    .5,
    Number(opts.range||100)/100
   );

  const hold=
   Number(opts.hold??45)/100;

  el.style.setProperty(
   '--story-view-height',
   height+'px'
  );

  el.style.setProperty(
   '--story-scene-height',
   height+'px'
  );

  el.style.setProperty(
   '--story-total-height',
   (
    enabled
     ? height*(
        1+
        range+
        .12+
        .85+
        ingredientSpan+
        hold+
        pouchSpan+
        (
         finale&&mq.matches
          ? 1
          : 0
        )
       )
     : height
   )+'px'
  );

  el.dataset.storyReady=
   String(enabled);

  const sceneTop=
   scene.getBoundingClientRect().top;

  textExit=
   words
    ? words.getBoundingClientRect().bottom-
      sceneTop+
      24
    : height;

  if(art){
   const rect=
    art.getBoundingClientRect();

   const square=
    $('.pt-story-chocolate-crop',art);

   const distance=
    Number(
     mq.matches
      ? opts.mobileIntensity??45
      : opts.intensity??45
    )/100;

   const lift=
    opts.direction==='down'
     ? 0
     : (square?.offsetHeight||0)*
       distance;

   artShift=
    height/2-
    (rect.height-lift)/2-
    (rect.top-sceneTop);

   el.style.setProperty(
    '--story-final-art-height',
    (rect.height+lift)+'px'
   );

   el.style.setProperty(
    '--story-final-art-width',
    rect.width+'px'
   );

   pairCentre=
    rect.top-
    sceneTop+
    artShift+
    rect.height/2;

   pairBottom=
    rect.height/2;
  }

  if(finale){
   const points=
    $('.pt-pouch-points',finale);

   const image=
    $('.pt-pouch-art img',finale);

   const mobileRoom=
    height-
    80-
    24-
    points.offsetHeight-
    (
     $('.sticky-buy')?.offsetHeight||
     74
    )-
    20;

   pouchHeight=
    mq.matches
     ? Math.max(
        100,
        Math.min(
         Math.min(
          160,
          height*.24
         )*
         4317/2835,
         mobileRoom
        )
       )
     : points.offsetHeight;

   pouchTop=
    mq.matches
     ? 80
     : Math.max(
        86,
        (height-pouchHeight)/2
       );

   el.style.setProperty(
    '--pouch-final-height',
    pouchHeight+'px'
   );

   el.style.setProperty(
    '--pouch-final-width',
    (
     pouchHeight*
     (
      image.naturalWidth/
      image.naturalHeight||
      2835/4317
     )
    )+'px'
   );

   el.style.setProperty(
    '--pouch-final-top',
    pouchTop+'px'
   );
  }

  if(enabled&&ingredients){
   const grid=
    $('.pt-ingredient-quadrants',ingredients);

   const gridBottom=
    Math.max(
     ...$$(
      '.pt-ingredient-mask',
      ingredients
     ).map(mask=>
      mask.getBoundingClientRect().bottom-
      sceneTop
     )
    );

   const artBottom=
    height/2+
    (
     parseFloat(
      el.style.getPropertyValue(
       '--story-final-art-height'
      )
     )||0
    )/2;

   const contentBottom=
    Math.max(
     gridBottom,
     artBottom
    );

   el.style.setProperty(
    '--ingredient-cta-top',
    (
     contentBottom+
     (
      parseFloat(
       getComputedStyle(el)
        .getPropertyValue(
         '--ing-cta-gap'
        )
      )||64
     )
    )+'px'
   );

   const readingHeight=
    Math.max(
     height,
     contentBottom+80,
     ingredientCTA
      ? contentBottom+
        (
         parseFloat(
          getComputedStyle(el)
           .getPropertyValue(
            '--ing-cta-gap'
           )
         )||64
        )+
        ingredientCTA.offsetHeight+
        80
      : 0
    );

   readingExtra=
    Math.max(
     0,
     readingHeight-height
    );

   el.style.setProperty(
    '--story-scene-height',
    readingHeight+'px'
   );

   el.style.setProperty(
    '--story-total-height',
    (
     height*(
      1+
      range+
      .12+
      .85+
      ingredientSpan+
      hold+
      pouchSpan+
      (
       finale&&mq.matches
        ? 1
        : 0
      )
     )+
     readingHeight-
     height
    )+'px'
   );
  }

  const trigger=
   mq.matches
    ? innerHeight*
      Number(
       opts.mobileTrigger??50
      )/
      100-
      height/2
    : innerHeight*
      Number(
       opts.desktopTrigger??15
      )/
      100;

  el.style.setProperty(
   '--ingredients-anchor-y',
   (
    enabled
     ? height*(
        range+
        .12+
        .85+
        ingredientSpan
       )-
       trigger+
       (
        parseFloat(
         getComputedStyle(
          document.documentElement
         ).scrollPaddingTop
        )||0
       )
     : ingredients
      ? ingredients.getBoundingClientRect().top-
        el.getBoundingClientRect().top
      : 0
   )+'px'
  );

  render();
 }

 function drawConnectors(progress){
  if(
   !connectors||
   !ingredients||
   !art
  )return;

  const box=
   ingredients.getBoundingClientRect();

  const square=
   $('.pt-story-chocolate-crop',art)
    ?.getBoundingClientRect();

  const wrapper=
   $('.pt-story-wrapper-crop',art)
    ?.getBoundingClientRect();

  if(!square||!wrapper)return;

  const anchors=[
   [
    square.left+
    square.width*.02,
    square.top+
    square.height*.02
   ],
   [
    square.right-
    square.width*.02,
    square.top+
    square.height*.02
   ],
   [
    wrapper.left+
    wrapper.width*.07,
    wrapper.bottom-
    wrapper.height*.03
   ],
   [
    wrapper.right-
    wrapper.width*.07,
    wrapper.bottom-
    wrapper.height*.03
   ]
  ];

  $$(
   'path',
   connectors
  ).forEach((path,i)=>{
   const heading=
    $$('.pt-ingredient-callout h3',ingredients)[i];

   if(!heading)return;

   const range=
    document.createRange();

   range.selectNodeContents(heading);

   const h=
    range.getBoundingClientRect();

   const left=
    i%2===0;

   const x=
    (
     left
      ? h.right+12
      : h.left-12
    )-
    box.left;

   const y=
    h.top+
    h.height/2-
    box.top;

   const ax=
    anchors[i][0]-
    box.left;

   const ay=
    anchors[i][1]-
    box.top;

   const end=
    mq.matches
     ? (
        left
         ? h.left-8
         : h.right+8
       )-
       box.left
     : x;

   const rail=
    left
     ? 4+i*2
     : box.width-
       4-
       i*2;

   path.setAttribute(
    'd',
    mq.matches
     ? `M ${ax} ${ay} L ${rail} ${ay+22} L ${rail} ${y} L ${end} ${y}`
     : `M ${ax} ${ay} L ${(ax+x)/2} ${y} L ${x} ${y}`
   );
  });

  connectors.style.setProperty(
   '--connector-progress',
   String(progress)
  );
 }

 function render(){
  frame=0;

  const top=
   el.getBoundingClientRect().top;

  const range=
   Math.max(
    .5,
    Number(opts.range||100)/100
   );

  const trigger=
   mq.matches
    ? innerHeight*
      Number(
       opts.mobileTrigger??50
      )/
      100-
      height/2
    : innerHeight*
      Number(
       opts.desktopTrigger??15
      )/
      100;

  const travel=
   trigger-top;

  const progress=
   enabled
    ? clamp(
       travel/(height*range)
      )
    : 1;

  const duration=
   rows.length*.6+.45;

  const time=
   progress*duration;

  rows.forEach((row,i)=>
   row.style.transform=
    `translateY(${(1-ease((time-i*.6)/.6))*105}%)`
  );

  const lift=
   enabled
    ? ease(
       (time-rows.length*.6)/.45
      )
    : 1;

  if(art){
   art.style.setProperty(
    '--story-lift',
    String(lift)
   );

   const distance=
    Number(
     mq.matches
      ? opts.mobileIntensity??45
      : opts.intensity??45
    );

   const direction=
    opts.direction==='down'
     ? 1
     : -1;

   art.style.setProperty(
    '--square-y',
    (
     direction*
     distance*
     lift
    )+'%'
   );
  }

  const settle=
   enabled
    ? smooth(
       (
        travel-
        height*range-
        height*.12
       )/
       (
        height*.85
       )
      )
    : 0;

  const entrance=
   enabled
    ? smooth(
       (progress-.02)/.38
      )
    : 1;

  el.style.setProperty(
   '--story-text-y',
   (-textExit*settle)+'px'
  );

  el.style.setProperty(
   '--story-text-opacity',
   String(
    1-
    smooth(
     (settle-.65)/.35
    )
   )
  );

  el.style.setProperty(
   '--story-art-y',
   (artShift*settle)+'px'
  );

  el.style.setProperty(
   '--story-white',
   String(settle)
  );

  el.style.setProperty(
   '--story-sides-opacity',
   String(
    entrance*
    (1-settle)
   )
  );

  el.style.setProperty(
   '--story-side-y',
   (
    -35*
    (1-entrance)-
    60*
    settle
   )+'px'
  );

  el.style.setProperty(
   '--story-side-blur',
   (
    6*
    (1-entrance)
   )+'px'
  );

  const ingredientProgress=
   enabled
    ? clamp(
       (
        travel-
        height*(
         range+
         .12+
         .85+
         .12
        )
       )/
       (
        height*.9
       )
      )
    : 1;

  ingredientRows.forEach((row,i)=>{
   if(
    row.classList.contains(
     'pt-ingredient-callout'
    )
   ){
    row.dataset.cloudState=
     !enabled
      ? 'static'
      : ingredientProgress>i*.12
       ? 'enter'
       : 'hidden';

   }else{
    row.style.transform=
     `translateY(${(1-ease((ingredientProgress-i*.12)/.45))*105}%)`;
   }
  });

  if(ingredients){
   ingredients.setAttribute(
    'aria-hidden',
    String(
     enabled&&
     ingredientProgress===0
    )
   );
  }

  if(ingredientCTA){
   const visible=
    !enabled||
    ingredientProgress>=.85;

   ingredientCTA.style.opacity=
    String(
     enabled
      ? ease(
         (ingredientProgress-.85)/.15
        )
      : 1
    );

   ingredientCTA.style.visibility=
    visible
     ? 'visible'
     : 'hidden';

   ingredientCTA.inert=
    !visible;
  }

  const afterReveal=
   travel/height-
   (
    range+
    .12+
    .85+
    1.02
   );

  const lineProgress=
   enabled
    ? ease(
       afterReveal/.5
      )
    : 1;

  drawConnectors(lineProgress);

  if(finale){
   const hold=
    Number(opts.hold??10)/100;

   const readStart=
    range+
    .12+
    .85+
    ingredientSpan;

   const camera=
    enabled&&mq.matches
     ? readingExtra*
       smooth(
        (
         travel/height-
         readStart
        )/
        1
       )
     : 0;

   const exitTime=
    enabled
     ? Math.max(
        0,
        travel/height-
        (
         readStart+
         hold+
         (
          mq.matches
           ? 1
           : 0
         )
        )
       )
     : 0;

   const t=
    enabled
     ? Math.max(
        0,
        exitTime-.9
       )
     : 4.6;

   if(
    enabled&&
    exitTime>0
   ){
    ingredientRows.forEach((row,i)=>{
     if(
      row.classList.contains(
       'pt-ingredient-callout'
      )
     ){
      row.dataset.cloudState='exit';

     }else{
      row.style.transform=
       `translateY(${-105*ease((exitTime-i*.07)/.45)}%)`;
     }
    });

    drawConnectors(
     lineProgress*
     (
      1-
      ease(exitTime/.5)
     )
    );

    if(ingredientCTA){
     ingredientCTA.style.opacity=
      String(
       1-
       ease(exitTime/.45)
      );

     ingredientCTA.inert=true;
    }
   }

   const entry=
    enabled
     ? smooth(t/.75)
     : 0;

   const shrink=
    enabled
     ? smooth(t/.8)
     : 0;

   const drop=
    enabled
     ? Math.pow(
        clamp(
         (t-1.05)/.75
        ),
        2
       )
     : 1;

   const expand=
    enabled
     ? smooth(
        (t-1.95)/.7
       )
     : 1;

   const shift=
    enabled
     ? smooth(
        (t-2.75)/.65
       )
     : 1;

   const initialScale=.76;
   const smallPair=.3;

   const pairLift=
    Math.min(
     height*.14,
     120
    );

   const initialTop=
    pairCentre-
    pairLift+
    pairBottom*
    smallPair+
    8;

   const bagTop=
    initialTop+
    (
     pouchTop-
     initialTop
    )*
    expand;

   const fallDistance=
    initialTop+
    pouchHeight*
    initialScale*
    .52-
    (
     pairCentre-
     pairLift
    );

   el.style.setProperty(
    '--story-camera',
    (-camera)+'px'
   );

   el.style.setProperty(
    '--pouch-camera',
    camera+'px'
   );

   const background=
    enabled
     ? smooth(
        (t-1.95)/.85
       )
     : 0;

   el.style.setProperty(
    '--pouch-background',
    String(background)
   );

   el.style.setProperty(
    '--pouch-background-edge',
    (
     120-
     140*
     background
    )+'%'
   );

   el.style.setProperty(
    '--pouch-background-tail',
    String(
     background===1
      ? 1
      : 0
    )
   );

   el.style.setProperty(
    '--ingredients-opacity',
    String(
     enabled
      ? 1-
        smooth(
         (exitTime-.73)/.07
        )
      : 1
    )
   );

   el.style.setProperty(
    '--pouch-opacity',
    String(
     enabled
      ? smooth(
         (t-.65)/.3
        )
      : 1
    )
   );

   el.style.setProperty(
    '--pouch-pair-scale',
    String(
     1-
     (
      1-
      smallPair
     )*
     shrink
    )
   );

   el.style.setProperty(
    '--pouch-pair-opacity',
    String(
     enabled
      ? 1-
        smooth(
         (drop-.9)/.1
        )
      : 1
    )
   );

   el.style.setProperty(
    '--story-art-y',
    (
     enabled
      ? artShift*
        settle+
        camera*
        entry-
        pairLift*
        shrink+
        fallDistance*
        drop
      : 0
    )+'px'
   );

   el.style.setProperty(
    '--pouch-top',
    bagTop+'px'
   );

   el.style.setProperty(
    '--pouch-scale',
    String(
     initialScale+
     (
      1-
      initialScale
     )*
     expand
    )
   );

   el.style.setProperty(
    '--pouch-x',
    (
     mq.matches
      ? 0
      : -innerWidth*
        .24*
        shift
    )+'px'
   );

   pouchPoints.forEach((point,i)=>{
    const p=
     enabled
      ? ease(
         (
          t-
          3.35-
          i*.2
         )/
         .45
        )
      : 1;

    point.style.setProperty(
     '--point-y',
     (
      (
       1-p
      )*
      105
     )+'%'
    );

    point.style.setProperty(
     '--point-opacity',
     String(p)
    );
   });

   finale.setAttribute(
    'aria-hidden',
    String(
     enabled&&
     t===0
    )
   );

   if(ingredients){
    ingredients.inert=
     enabled&&
     exitTime>0;

    ingredients.setAttribute(
     'aria-hidden',
     String(
      enabled&&
      (
       ingredientProgress===0||
       exitTime>=.8
      )
     )
    );
   }
  }

  el.dataset.storyProgress=
   progress.toFixed(3);

  el.dataset.storySettle=
   settle.toFixed(3);

  el.dataset.ingredientProgress=
   ingredientProgress.toFixed(3);
 }

 function queue(){
  if(!frame){
   frame=
    requestAnimationFrame(render);
  }
 }

 const resize=
  new ResizeObserver(()=>{
   const width=
    scene.clientWidth;

   if(width!==lastWidth){
    lastWidth=width;
    measure();
   }
  });

 resize.observe(scene);

 window.addEventListener(
  'scroll',
  queue,
  {
   passive:true,
   signal
  }
 );

 window.addEventListener(
  'resize',
  measure,
  {signal}
 );

 document.addEventListener(
  'pt:motion-change',
  measure,
  {signal}
 );

 matchMedia(
  '(prefers-reduced-motion: reduce)'
 ).addEventListener(
  'change',
  measure,
  {signal}
 );

 $$('img',scene).forEach(img=>
  img.addEventListener(
   'load',
   measure,
   {signal}
  )
 );

 document.fonts.ready.then(()=>{
  if(!signal.aborted){
   measure();

   if(
    ingredients&&
    location.hash==='#ingredients'
   ){
    $('.pt-story-anchor',el)
     ?.scrollIntoView({
      behavior:'instant'
     });
   }
  }
 });

 signal.addEventListener(
  'abort',
  ()=>{
   cancelAnimationFrame(frame);

   resize.disconnect();

   lines.forEach(line=>
    line.innerHTML=
     originals.get(line)
   );
  }
 );

 measure();
}

function initBlogCarousel(el,signal){
 const slides=
  $$('[data-blog-slide]',el);

 const controls=
  $('.pt-journal-controls',el);

 const dots=
  $('.pt-journal-dots',el);

 const pause=
  $('[data-blog-pause]',el);

 if(!slides.length)return;

 let index=0;
 let timer;
 let paused=false;
 let hover=false;
 let focused=false;
 let visible=true;

 const interval=
  Math.max(
   3000,
   Number(el.dataset.interval)||3000
  );

 const schedule=()=>{
  clearTimeout(timer);

  if(
   slides.length>1&&
   el.dataset.autoplay==='true'&&
   !paused&&
   !hover&&
   !focused&&
   visible&&
   !document.hidden&&
   !reduced()&&
   !config.designMode
  ){
   timer=setTimeout(()=>{
    show(index+1);
   },interval);
  }
 };

 const show=n=>{
  index=
   (n+slides.length)%slides.length;

  slides.forEach((slide,i)=>{
   slide.classList.toggle(
    'is-active',
    i===index
   );

   slide.inert=
    i!==index;

   slide.setAttribute(
    'aria-hidden',
    String(i!==index)
   );
  });

  $$('button',dots).forEach((b,i)=>
   b.setAttribute(
    'aria-current',
    String(i===index)
   )
  );

  schedule();
 };

 slides.forEach((slide,i)=>{
  slide.setAttribute(
   'role',
   'group'
  );

  slide.setAttribute(
   'aria-roledescription',
   'slide'
  );

  slide.setAttribute(
   'aria-label',
   `${i+1} of ${slides.length}`
  );

  const b=
   document.createElement('button');

  b.type='button';

  b.setAttribute(
   'aria-label',
   `Show blog slide ${i+1}`
  );

  b.addEventListener(
   'click',
   ()=>show(i),
   {signal}
  );

  dots.append(b);
 });

 el.dataset.ready='true';

 controls.hidden=
  slides.length<2;

 pause.hidden=
  el.dataset.autoplay!=='true';

 show(0);

 pause.addEventListener(
  'click',
  ()=>{
   paused=!paused;

   pause.textContent=
    paused
     ? '▶'
     : 'Ⅱ';

   pause.setAttribute(
    'aria-label',
    paused
     ? 'Play blog carousel'
     : 'Pause blog carousel'
   );

   schedule();
  },
  {signal}
 );

 el.addEventListener(
  'mouseenter',
  ()=>{
   hover=true;
   schedule();
  },
  {signal}
 );

 el.addEventListener(
  'mouseleave',
  ()=>{
   hover=false;
   schedule();
  },
  {signal}
 );

 el.addEventListener(
  'focusin',
  ()=>{
   focused=true;
   schedule();
  },
  {signal}
 );

 el.addEventListener(
  'focusout',
  e=>{
   focused=
    el.contains(e.relatedTarget);

   schedule();
  },
  {signal}
 );

 dots.addEventListener(
  'keydown',
  e=>{
   if(
    ![
     'ArrowLeft',
     'ArrowRight',
     'Home',
     'End'
    ].includes(e.key)
   )return;

   e.preventDefault();

   show(
    e.key==='Home'
     ? 0
     : e.key==='End'
      ? slides.length-1
      : index+
        (
         e.key==='ArrowRight'
          ? 1
          : -1
        )
   );

   $$('button',dots)[index]
    .focus();
  },
  {signal}
 );

 el.addEventListener(
  'shopify:block:select',
  e=>{
   const i=
    slides.indexOf(
     e.target.closest(
      '[data-blog-slide]'
     )
    );

   if(i>=0){
    paused=true;
    show(i);
   }
  },
  {signal}
 );

 const observer=
  new IntersectionObserver(entries=>{
   visible=
    entries[0].isIntersecting;

   schedule();
  });

 observer.observe(el);

 document.addEventListener(
  'visibilitychange',
  schedule,
  {signal}
 );

 document.addEventListener(
  'pt:motion-change',
  schedule,
  {signal}
 );

 matchMedia(
  '(prefers-reduced-motion: reduce)'
 ).addEventListener(
  'change',
  schedule,
  {signal}
 );

 signal.addEventListener(
  'abort',
  ()=>{
   clearTimeout(timer);
   observer.disconnect();
   dots.replaceChildren();
  }
 );
}

function initInstagramWall(el,signal){
 const rows=
  $('.pt-instagram-rows',el);

 const sources=
  $$('.pt-instagram-sources .pt-instagram-photo',el);

 const build=items=>{
  if(
   signal.aborted||
   !items.length
  )return;

  rows.replaceChildren();

  for(let r=0;r<3;r++){
   const row=
    document.createElement('div');

   const track=
    document.createElement('div');

   const group=
    document.createElement('div');

   row.className=
    'pt-instagram-row';

   track.className=
    'pt-instagram-track';

   group.className=
    'pt-instagram-group';

   const count=
    Math.max(
     items.length,
     Math.ceil(innerWidth/100)+2
    );

   for(let i=0;i<count;i++){
    const photo=
     items[
      (
       i+
       r*2
      )%
      items.length
     ].cloneNode(true);

    photo.removeAttribute(
     'data-shopify-editor-block'
    );

    photo.href=
     el.dataset.instagramUrl;

    group.append(photo);
   }

   const duplicate=
    group.cloneNode(true);

   duplicate.setAttribute(
    'aria-hidden',
    'true'
   );

   duplicate.inert=true;

   track.append(
    group,
    duplicate
   );

   row.append(track);

   rows.append(row);
  }

  el.dataset.ready='true';
 };

 build(sources);

 const observer=
  new IntersectionObserver(entries=>{
   rows.style.setProperty(
    'visibility',
    entries[0].isIntersecting
     ? 'visible'
     : 'hidden'
   );
  });

 observer.observe(el);

 signal.addEventListener(
  'abort',
  ()=>observer.disconnect()
 );

 if(el.dataset.feedUrl){
  try{
   const url=
    new URL(
     el.dataset.feedUrl,
     location.origin
    );

   if(url.origin!==location.origin){
    throw Error(
     'Instagram feed must use a same-store app proxy.'
    );
   }

   fetch(
    url,
    {
     signal,
     credentials:'same-origin',
     headers:{
      Accept:'application/json'
     }
    }
   )
    .then(r=>{
     if(!r.ok){
      throw Error(
       'Instagram feed unavailable'
      );
     }

     return r.json();
    })
    .then(payload=>{
     const items=
      (
       Array.isArray(payload)
        ? payload
        : payload.data||[]
      )
       .slice(0,30)
       .flatMap(post=>{
        const src=
         post.media_type==='VIDEO'
          ? post.thumbnail_url
          : post.media_url||
            post.image_url;

        if(!src)return[];

        let parsed;

        try{
         parsed=new URL(src);
        }catch{
         return[];
        }

        if(parsed.protocol!=='https:'){
         return[];
        }

        const a=
         document.createElement('a');

        a.className=
         'pt-instagram-photo';

        const img=
         document.createElement('img');

        img.src=
         parsed.href;

        img.alt=
         (
          post.caption||
          'Pillow Talk on Instagram'
         ).slice(0,160);

        img.loading='lazy';
        img.width=700;
        img.height=700;

        a.append(img);

        return[a];
       });

     if(items.length){
      build(items);

      el.dataset.feedStatus=
       'connected';

      const note=
       $('.pt-social-setup',el);

      if(note){
       note.textContent=
        'Connected Instagram feed';
      }

     }else{
      el.dataset.feedStatus='empty';
     }
    })
    .catch(e=>{
     if(e.name!=='AbortError'){
      el.dataset.feedStatus=
       'unavailable';
     }
    });

  }catch{
   el.dataset.feedStatus=
    'invalid-url';
  }
 }
}

function initFan(el,signal){
 const orbits=
  $$('.fan-orbit',el);

 if(!orbits.length)return;

 let phase=2;
 let last=0;
 let frame=0;
 let visible=false;
 let paused=false;

 let control=
  $('.fan-pause',el);

 if(!control){
  control=
   document.createElement('button');

  control.className=
   'fan-pause';

  control.type='button';

  control.setAttribute(
   'aria-label',
   'Pause social animation'
  );

  control.textContent='Ⅱ';

  el.append(control);
 }

 control.addEventListener(
  'click',
  ()=>{
   paused=!paused;

   control.textContent=
    paused
     ? '▶'
     : 'Ⅱ';

   control.setAttribute(
    'aria-label',
    paused
     ? 'Play social animation'
     : 'Pause social animation'
   );
  },
  {signal}
 );

 const observer=
  new IntersectionObserver(
   e=>
    visible=e.some(
     x=>x.isIntersecting
    ),
   {
    rootMargin:
     '-10% 0px -10% 0px',
    threshold:.2
   }
  );

 observer.observe(el);

 function loop(t){
  if(
   last&&
   visible&&
   !paused&&
   !reduced()&&
   !document.hidden&&
   !config.designMode
  ){
   phase+=
    Math.min(
     t-last,
     64
    )/
    (
     1000*
     (
      Number(el.dataset.speed)||
      3
     )
    );
  }

  last=t;

  orbits.forEach((orbit,i)=>{
   let rel=
    i-
    phase%
    orbits.length;

   while(
    rel>
    orbits.length/2
   ){
    rel-=orbits.length;
   }

   while(
    rel<
    -orbits.length/2
   ){
    rel+=orbits.length;
   }

   orbit.style.transform=
    `translateX(-50%) rotate(${rel*Number(innerWidth>=992?el.dataset.angle:el.dataset.mobileAngle)}deg)`;
  });

  frame=
   requestAnimationFrame(loop);
 }

 frame=
  requestAnimationFrame(loop);

 signal.addEventListener(
  'abort',
  ()=>{
   cancelAnimationFrame(frame);
   observer.disconnect();
  }
 );
}

function initImages(scope,signal){
 $$(
  'img[data-mobile-src]',
  scope
 ).forEach(img=>{
  const desktop=
   img.dataset.desktopSrc||
   img.src;

  img.dataset.desktopSrc=
   desktop;

  const mq=
   matchMedia(
    '(max-width:767px)'
   );

  const update=()=>{
   img.src=
    mq.matches
     ? img.dataset.mobileSrc
     : desktop;
  };

  mq.addEventListener(
   'change',
   update,
   {signal}
  );

  update();
 });
}

function initProductCarousel(el,signal){
 const track=
  $('[data-carousel-track]',el);

 const prev=
  $('[data-carousel-prev]',el);

 const next=
  $('[data-carousel-next]',el);

 if(!track)return;

 const update=()=>{
  const max=
   Math.max(
    0,
    track.scrollWidth-
    track.clientWidth
   );

  el.hidden=
   !track.children.length;

  prev.disabled=
   track.scrollLeft<=1;

  next.disabled=
   track.scrollLeft>=max-1;

  prev.parentElement.hidden=
   max<2;

  $$('video',track).forEach(video=>{
   const rect=
    video.getBoundingClientRect();

   const bounds=
    track.getBoundingClientRect();

   if(
    rect.right<=bounds.left||
    rect.left>=bounds.right
   ){
    video.pause();
   }
  });
 };

 const move=direction=>
  track.scrollBy({
   left:
    direction*
    (
     (
      track.firstElementChild
       ?.getBoundingClientRect()
       .width||
      track.clientWidth
     )+
     16
    ),
   behavior:
    reduced()
     ? 'instant'
     : 'smooth'
  });

 prev.addEventListener(
  'click',
  ()=>move(-1),
  {signal}
 );

 next.addEventListener(
  'click',
  ()=>move(1),
  {signal}
 );

 track.addEventListener(
  'scroll',
  update,
  {
   passive:true,
   signal
  }
 );

 track.addEventListener(
  'keydown',
  e=>{
   if(e.target!==track)return;

   if(
    e.key==='ArrowRight'||
    e.key==='ArrowLeft'
   ){
    e.preventDefault();

    move(
     e.key==='ArrowRight'
      ? 1
      : -1
    );
   }
  },
  {signal}
 );

 const observer=
  new ResizeObserver(update);

 observer.observe(track);

 document.fonts.ready.then(()=>{
  if(!signal.aborted){
   update();
  }
 });

 signal.addEventListener(
  'abort',
  ()=>observer.disconnect()
 );

 update();

 if(
  el.classList.contains(
   'pt-product-carousel--reviews'
  )
 ){
  const motion=
   matchMedia(
    '(prefers-reduced-motion: reduce)'
   );

  let timer=null;
  let visible=false;
  let hover=false;

  const schedule=()=>{
   clearTimeout(timer);

   if(
    signal.aborted||
    !visible||
    hover||
    el.contains(document.activeElement)||
    document.hidden||
    reduced()||
    config.designMode||
    track.children.length<2
   )return;

   timer=setTimeout(()=>{
    const max=
     track.scrollWidth-
     track.clientWidth;

    if(max>1){
     if(
      track.scrollLeft>=
      max-2
     ){
      track.scrollTo({
       left:0,
       behavior:'smooth'
      });
     }else{
      move(1);
     }
    }

    schedule();
   },3000);
  };

  el.addEventListener(
   'pointerenter',
   e=>{
    if(e.pointerType==='mouse'){
     hover=true;
     schedule();
    }
   },
   {signal}
  );

  el.addEventListener(
   'pointerleave',
   ()=>{
    hover=false;
    schedule();
   },
   {signal}
  );

  el.addEventListener(
   'focusin',
   schedule,
   {signal}
  );

  el.addEventListener(
   'focusout',
   ()=>queueMicrotask(schedule),
   {signal}
  );

  track.addEventListener(
   'pointerdown',
   ()=>clearTimeout(timer),
   {signal}
  );

  track.addEventListener(
   'pointerup',
   schedule,
   {signal}
  );

  document.addEventListener(
   'visibilitychange',
   schedule,
   {signal}
  );

  document.addEventListener(
   'pt:motion-change',
   schedule,
   {signal}
  );

  motion.addEventListener(
   'change',
   schedule,
   {signal}
  );

  const visibility=
   new IntersectionObserver(
    entries=>{
     visible=
      entries.some(
       e=>e.isIntersecting
      );

     schedule();
    },
    {
     threshold:.25
    }
   );

  visibility.observe(el);

  signal.addEventListener(
   'abort',
   ()=>{
    clearTimeout(timer);
    visibility.disconnect();
   }
  );
 }
}

function initDifferentialColumns(box,signal){
 const left=
  $('.pt-gallery-column',box);

 const right=
  $('.pt-purchase-column',box);

 if(!left||!right)return;

 const update=()=>{
  box.style.setProperty(
   '--gallery-column-height',
   `${left.offsetHeight}px`
  );

  box.classList.toggle(
   'has-differential-scroll',
   right.offsetHeight>
   left.offsetHeight+1
  );
 };

 const observer=
  new ResizeObserver(update);

 observer.observe(left);
 observer.observe(right);

 signal.addEventListener(
  'abort',
  ()=>observer.disconnect()
 );

 update();
}

function initNotification(el,signal){
 const cards=
  $$('.pt-notification-card',el);

 if(!cards.length)return;

 let index=0;
 let animation=null;
 let visible=false;

 const motion=
  matchMedia(
   '(prefers-reduced-motion: reduce)'
  );

 const stop=()=>{
  if(animation){
   animation.onfinish=null;
   animation.cancel();
   animation=null;
  }
 };

 const play=()=>{
  stop();

  cards.forEach((card,i)=>
   card.classList.toggle(
    'is-current',
    i===index
   )
  );

  if(
   signal.aborted||
   !visible||
   document.hidden||
   reduced()||
   config.designMode||
   cards.length<2
  )return;

  animation=
   cards[index].animate(
    [
     {
      opacity:0,
      transform:'translateY(16px)',
      offset:0,
      easing:'ease-out'
     },
     {
      opacity:1,
      transform:'translateY(0)',
      offset:.18
     },
     {
      opacity:1,
      transform:'translateY(0)',
      offset:.78
     },
     {
      opacity:0,
      transform:'translateY(-8px)',
      offset:.86
     },
     {
      opacity:0,
      transform:'translateY(-8px)',
      offset:1
     }
    ],
    {
     duration:5000,
     easing:'linear',
     fill:'both'
    }
   );

  animation.onfinish=()=>{
   index=
    (index+1)%cards.length;

   play();
  };
 };

 const observer=
  new IntersectionObserver(entries=>{
   visible=
    entries.some(
     entry=>entry.isIntersecting
    );

   play();
  });

 observer.observe(el);

 motion.addEventListener(
  'change',
  play,
  {signal}
 );

 document.addEventListener(
  'pt:motion-change',
  play,
  {signal}
 );

 document.addEventListener(
  'visibilitychange',
  play,
  {signal}
 );

 signal.addEventListener(
  'abort',
  ()=>{
   stop();
   observer.disconnect();
  }
 );
}

function initRitualSteps(el,signal){
 const steps=
  $$('.pt-ritual-step',el);

 const duration=
  (
   Number(el.dataset.seconds)||
   5
  )*
  1000;

 const bridge=650;

 const cycle=
  steps.length*
  (
   duration+
   bridge
  );

 if(!steps.length)return;

 let visible=false;
 let last=0;
 let time=0;
 let frame=0;

 const observer=
  new IntersectionObserver(
   entries=>{
    visible=
     entries.some(
      e=>e.isIntersecting
     );

    if(visible){
     el.classList.add(
      'has-entered'
     );
    }
   },
   {
    threshold:.15
   }
  );

 observer.observe(el);

 function tick(now){
  if(
   last&&
   visible&&
   !document.hidden&&
   !reduced()&&
   !config.designMode
  ){
   time=
    (
     time+
     Math.min(
      now-last,
      80
     )
    )%
    cycle;
  }

  last=now;

  steps.forEach((step,i)=>{
   const local=
    time-
    i*
    (
     duration+
     bridge
    );

   const staticView=
    reduced()||
    config.designMode;

   step.classList.toggle(
    'is-active',
    staticView||
    (
     local>=0&&
     local<
     duration+
     bridge
    )
   );

   step.style.setProperty(
    '--step-fill',
    staticView
     ? 1
     : clamp(
        local/duration
       )
   );

   step.style.setProperty(
    '--line-fill',
    staticView
     ? 1
     : clamp(
        (
         local-
         duration
        )/
        bridge
       )
   );
  });

  frame=
   requestAnimationFrame(tick);
 }

 frame=
  requestAnimationFrame(tick);

 signal.addEventListener(
  'abort',
  ()=>{
   cancelAnimationFrame(frame);
   observer.disconnect();
  }
 );
}

function initIngredientCards(el,signal){
 const dialog=
  el.parentElement.querySelector(
   '[data-ingredient-dialog]'
  );

 if(!dialog)return;

 const cards=
  $$(
   '[data-ingredient-detail]',
   dialog
  );

 const triggers=
  $$(
   '[data-ingredient-open]',
   el
  );

 if(!cards.length)return;

 const marker=
  document.createComment(
   'ingredient dialog'
  );

 dialog.before(marker);

 document.body.append(dialog);

 let index=0;
 let opener=null;

 const show=i=>{
  index=
   (
    i+
    cards.length
   )%
   cards.length;

  cards.forEach((card,n)=>{
   card.hidden=
    n!==index;
  });

  dialog.setAttribute(
   'aria-label',
   $('h2',cards[index]).textContent
  );

  $('[data-ingredient-counter]',dialog).textContent=
   `${index+1} / ${cards.length}`;
 };

 const close=()=>
  dialog.close();

 triggers.forEach((button,i)=>
  button.addEventListener(
   'click',
   ()=>{
    opener=button;

    $$(
     '[data-ingredient-dialog][open]'
    ).forEach(other=>
     other.close()
    );

    show(i);

    dialog.showModal();
   },
   {signal}
  )
 );

 $('[data-ingredient-close]',dialog)
  .addEventListener(
   'click',
   close,
   {signal}
  );

 $('[data-ingredient-prev]',dialog)
  .addEventListener(
   'click',
   ()=>show(index-1),
   {signal}
  );

 $('[data-ingredient-next]',dialog)
  .addEventListener(
   'click',
   ()=>show(index+1),
   {signal}
  );

 dialog.addEventListener(
  'click',
  e=>{
   if(e.target!==dialog)return;

   const r=
    dialog.getBoundingClientRect();

   if(
    e.clientX<r.left||
    e.clientX>r.right||
    e.clientY<r.top||
    e.clientY>r.bottom
   ){
    close();
   }
  },
  {signal}
 );

 dialog.addEventListener(
  'keydown',
  e=>{
   if(
    e.key==='ArrowRight'||
    e.key==='ArrowLeft'
   ){
    e.preventDefault();

    show(
     index+
     (
      e.key==='ArrowRight'
       ? 1
       : -1
     )
    );
   }
  },
  {signal}
 );

 dialog.addEventListener(
  'close',
  ()=>{
   if(opener?.isConnected){
    opener.focus({
     preventScroll:true
    });
   }
  },
  {signal}
 );

 signal.addEventListener(
  'abort',
  ()=>{
   dialog.close();

   if(marker.isConnected){
    marker.replaceWith(dialog);
   }else{
    dialog.remove();
   }
  }
 );
}

function initHighlight(el,signal){
 const context=
  document
   .createElement('canvas')
   .getContext('2d');

 if(!context)return;

 const update=()=>{
  if(
   signal.aborted||
   !el.textContent.trim()
  )return;

  const style=
   getComputedStyle(el);

  context.font=
   `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;

  const metrics=
   context.measureText(
    el.textContent
   );

  if(
   !Number.isFinite(
    metrics.fontBoundingBoxAscent
   )
  )return;

  const top=
   Math.max(
    0,
    metrics.fontBoundingBoxAscent-
    metrics.actualBoundingBoxAscent
   )/
   parseFloat(style.fontSize);

  el.style.setProperty(
   '--pt-highlight-top',
   `${top.toFixed(4)}em`
  );
 };

 const observer=
  new ResizeObserver(update);

 observer.observe(
  el.closest(
   '.pt-heading, .word-mask'
  )||
  el.parentElement
 );

 signal.addEventListener(
  'abort',
  ()=>observer.disconnect()
 );

 document.fonts.ready.then(update);

 update();
}

function init(scope=document){
 const find=s=>[
  ...(
   scope.matches?.(s)
    ? [scope]
    : []
  ),
  ...$$(s,scope)
 ];

 const bind=(selector,fn)=>
  find(selector).forEach(el=>{
   initializers.get(el)?.abort();

   const c=
    new AbortController();

   initializers.set(
    el,
    c
   );

   controllers.add(c);

   c.signal.addEventListener(
    'abort',
    ()=>controllers.delete(c)
   );

   fn(el,c.signal);
  });

 bind(
  '.pt-heading em, .word-mask em, .pt-purchase-title em, .pt-highlight-copy em',
  initHighlight
 );

 bind(
  '[data-product-form]',
  initForm
 );

 bind(
  '[data-gallery]',
  initGallery
 );

 bind(
  '[data-announcement]',
  initAnnouncement
 );

 bind(
  '[data-marquee]',
  initMarquee
 );

 bind(
  '.hero-props',
  initHeroNumbers
 );

 bind(
  '[data-notification]',
  initNotification
 );

 bind(
  '[data-product-carousel]',
  initProductCarousel
 );

 bind(
  '.buybox',
  initDifferentialColumns
 );

 bind(
  '[data-ritual-steps]',
  initRitualSteps
 );

 bind(
  '[data-story-ingredients]',
  initIngredientCards
 );

 bind(
  '[data-scroll-story]',
  initScroll
 );

 bind(
  '[data-social-fan]',
  initFan
 );

 bind(
  '[data-blog-carousel]',
  initBlogCarousel
 );

 bind(
  '[data-instagram-wall]',
  initInstagramWall
 );

 bind(
  'img[data-mobile-src]',
  (img,signal)=>{
   const desktop=
    img.dataset.desktopSrc||
    img.src;

   img.dataset.desktopSrc=
    desktop;

   const mq=
    matchMedia(
     '(max-width:767px)'
    );

   const update=()=>
    img.src=
     mq.matches
      ? img.dataset.mobileSrc
      : desktop;

   mq.addEventListener(
    'change',
    update,
    {signal}
   );

   update();
  }
 );

 updateShipping(scope);
 updateProofLinks();
}

function updateProofLinks(excluded){
 const proof=
  $('#after-hours');

 $$(
  'a[href$="#after-hours"]'
 ).forEach(a=>
  a.hidden=
   !proof||
   (
    !$('.r3-testimonial',proof)&&
    !proof.matches(
     '[data-instagram-wall]'
    )
   )||
   !!excluded?.contains(proof)
 );
}

function loadPrivacy(){
 const set=()=>{
  const state=
   window.Shopify
    ?.customerPrivacy
    ?.currentVisitorConsent
    ?.();

  if(!state)return;

  $$(
   '[data-consent]',
   overlay
  ).forEach(input=>
   input.checked=
    state[
     input.dataset.consent
    ]==='yes'
  );
 };

 if(
  window.Shopify
   ?.customerPrivacy
 ){
  set();

 }else if(
  window.Shopify
   ?.loadFeatures
 ){
  window.Shopify.loadFeatures(
   [
    {
     name:'consent-tracking-api',
     version:'0.1'
    }
   ],
   e=>{
    if(!e)set();
   }
  );
 }
}

/*
 * Listen for cart mutations coming from custom sections and from the native
 * commerce controls. Listening on document catches events dispatched from
 * documentElement as well because those events bubble.
 */
[
 'cart:refresh',
 'cart:updated',
 'cart:update',
 'pt:cart-mutated'
].forEach(eventName=>{
 document.addEventListener(
  eventName,
  handleExternalCartSignal
 );
});

/*
 * Small public bridge for any future custom section that needs the native cart
 * without duplicating drawer logic. Existing theme behaviour remains unchanged.
 */
window.PTThemeCart={
 open(trigger){
  openPanel('cart',trigger||document.activeElement);
 },
 refresh(){
  return loadCart();
 },
 updateCount(count){
  updateCartCount(Number(count)||0);
 },
 sync(cart,options={}){
  if(cart&&typeof cart==='object'){
   cartCache=cart;
   renderCart(cart);
  }else{
   loadCart();
  }

  if(options.open){
   openPanel('cart',options.trigger||document.activeElement);
   if(cart&&typeof cart==='object')renderCart(cart);
  }
 }
};

document.addEventListener(
 'click',
 async e=>{
  const close=
   e.target.closest(
    '[data-close-overlay],[data-close-link]'
   );

  if(close){
   closePanel();
   return;
  }

  if(
   e.target.closest(
    '[data-close-lightbox]'
   )
  ){
   lightbox.close();
   return;
  }

  if(
   e.target.closest(
    '[data-lightbox-prev]'
   )
  ){
   activeGallery?.move(-1);
   return;
  }

  if(
   e.target.closest(
    '[data-lightbox-next]'
   )
  ){
   activeGallery?.move(1);
   return;
  }

  const action=
   e.target.closest(
    '[data-action]'
   );

  if(action){
   const kind=
    action.dataset.action;

   if(kind==='add'){
    location.href=
     root+'#offers';

    return;
   }

   openPanel(
    kind,
    action
   );

   return;
  }

  const qty=
   e.target.closest(
    '[data-cart-line]'
   );

  if(qty&&!cartBusy){
   cartBusy=true;

   $$(
    '[data-cart-line]',
    overlay
   ).forEach(b=>
    b.disabled=true
   );

   try{
    cartCache=
     await request(
      config.cartChange||
      root+'cart/change.js',
      {
       method:'POST',
       body:JSON.stringify({
        id:qty.dataset.cartLine,
        quantity:Number(
         qty.dataset.cartQuantity
        )
       })
      }
     );

    renderCart(cartCache);

    const replacement=
     $$(
      '[data-cart-line]',
      overlay
     ).find(b=>
      b.dataset.cartLine===
      qty.dataset.cartLine
     );

    (
     replacement||
     $('.pt-overlay-close',overlay)
    ).focus();

    document.dispatchEvent(
     new CustomEvent(
      'cart:updated'
     )
    );

   }catch(error){
    const status=
     $('.pt-cart-status',overlay);

    if(status){
     status.textContent=
      error.message;
    }

    $$(
     '[data-cart-line]',
     overlay
    ).forEach(b=>
     b.disabled=false
    );

   }finally{
    cartBusy=false;
   }

   return;
  }

  const tab=
   e.target.closest(
    '.pt-tab-button'
   );

  if(tab){
   e.preventDefault();

   const group=
    tab.closest(
     '.pt-tabs'
    );

   group.dataset.active=
    tab
     .getAttribute('href')
     .includes('ritual')
      ? 'ritual'
      : 'chocolate';

   $$(
    '.pt-tab-button',
    group
   ).forEach(b=>
    b.classList.toggle(
     'active',
     b===tab
    )
   );

   return;
  }

  if(
   e.target.closest(
    '[data-save-preferences]'
   )
  ){
   try{
    localStorage.setItem(
     'pt-accessibility',
     JSON.stringify(
      preferences
     )
    );

    $(
     '[data-preference-status]',
     overlay
    ).textContent=
     tx('preferences_saved');

   }catch{
    $(
     '[data-preference-status]',
     overlay
    ).textContent=
     tx('preferences_unsaved');
   }

   return;
  }

  if(
   e.target.closest(
    '[data-save-consent]'
   )
  ){
   const status=
    $('[data-consent-status]',overlay);

   if(
    !window.Shopify
     ?.customerPrivacy
   ){
    status.textContent=
     tx('privacy_unavailable');

    return;
   }

   const consent={};

   $$(
    '[data-consent]',
    overlay
   ).forEach(i=>
    consent[
     i.dataset.consent
    ]=i.checked
   );

   window.Shopify.customerPrivacy
    .setTrackingConsent(
     consent,
     ()=>
      status.textContent=
       tx('privacy_saved')
    );

   return;
  }

  if(
   e.target.closest('a[href]')&&
   overlay?.open&&
   !e.target.closest(
    '.pt-tabs'
   )
  ){
   closePanel();
  }
 }
);

document.addEventListener(
 'change',
 e=>{
  const input=
   e.target.closest(
    '[data-preference]'
   );

  if(input){
   preferences[
    input.dataset.preference
   ]=input.checked;

   applyPrefs();
  }
 }
);

overlay?.addEventListener(
 'cancel',
 e=>{
  e.preventDefault();
  closePanel();
 }
);

overlay?.addEventListener(
 'click',
 e=>{
  const r=
   overlay.getBoundingClientRect();

  if(
   e.target===overlay&&
   (
    e.clientX<r.left||
    e.clientX>r.right||
    e.clientY<r.top||
    e.clientY>r.bottom
   )
  ){
   closePanel();
  }
 }
);

lightbox?.addEventListener(
 'click',
 e=>{
  if(e.target===lightbox){
   lightbox.close();
  }
 }
);

let lastY=scrollY;
let scrollFrame=0;

function updateScroll(){
 scrollFrame=0;

 const y=scrollY;

 const h=
  $('[data-header]');

 if(h){
  h.classList.toggle(
   'header-hidden',
   y>lastY&&
   y>150&&
   !overlay.open&&
   !config.designMode&&
   h.dataset.hideScroll!=='false'
  );

  h.classList.toggle(
   'scrolled',
   y>50
  );
 }

 lastY=y;
}

window.addEventListener(
 'scroll',
 ()=>{
  if(!scrollFrame){
   scrollFrame=
    requestAnimationFrame(
     updateScroll
    );
  }
 },
 {
  passive:true
 }
);

document.addEventListener(
 'shopify:section:load',
 e=>{
  const kind=
   overlay.open
    ? overlay.dataset.kind
    : null;

  if(moved){
   closePanel();
  }

  init(e.target);

  $$(
   '[data-marquee]'
  ).forEach(
   syncTickerJoin
  );

  if(
   kind&&
   $(
    `[data-overlay-source="${kind}"]`,
    e.target
   )
  ){
   openPanel(kind);
  }
 }
);

document.addEventListener(
 'shopify:section:unload',
 e=>{
  [
   e.target,
   ...$$('*',e.target)
  ].forEach(el=>
   initializers.get(el)?.abort()
  );

  updateProofLinks(
   e.target
  );

  if(
   moved&&
   e.target.contains(anchor)
  ){
   closePanel();
  }
 }
);

document.addEventListener(
 'shopify:block:select',
 e=>{
  const source=
   e.target.closest(
    '[data-overlay-source]'
   );

  if(
   source&&
   (
    !overlay.open||
    overlay.dataset.kind!==
    source.dataset.overlaySource
   )
  ){
   openPanel(
    source.dataset.overlaySource
   );

  }else if(
   !source&&
   overlay.open
  ){
   closePanel();
  }

  const gallery=
   e.target.closest(
    '[data-gallery]'
   );

  const slide=
   e.target.closest(
    '[data-gallery-slide]'
   );

  if(gallery&&slide){
   const i=
    $$(
     '[data-gallery-slide]',
     gallery
    ).indexOf(slide);

   $$(
    '[data-thumbnails] button',
    gallery
   )[i]?.click();
  }
 }
);

const stickyBuy=
 $('[data-sticky-buy]');

if(stickyBuy){
 const syncStickyHeight=()=>
  document.documentElement.style.setProperty(
   '--sticky-buy-height',
   `${Math.ceil(stickyBuy.getBoundingClientRect().height)}px`
  );

 new ResizeObserver(
  syncStickyHeight
 ).observe(stickyBuy);

 syncStickyHeight();
}

applyPrefs();

const sectionRoots=
 $$('.shopify-section');

if(sectionRoots.length){
 sectionRoots.forEach(init);
}else{
 init();
}

updateCartCount(
 Number(
  $('[data-cart-count]')?.textContent
 )||0
);

updateScroll();
})();
